import React, { useState } from 'react';
import './Onboarding.css';

interface OnboardingProps {
  onComplete: () => void;
}

const Onboarding: React.FC<OnboardingProps> = ({ onComplete }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState('English');

  const slides = [
    {
      title: 'Welcome to Sparkademy',
      description: 'Your gateway to quality education and learning resources. Start your learning journey today!',
      icon: '📚'
    },
    {
      title: 'Explore Courses',
      description: 'Access a wide range of courses, books, and online learning sessions. Learn at your own pace.',
      icon: '🎓'
    },
    {
      title: 'Get Started',
      description: 'Join thousands of students already learning with Sparkademy. Your future starts here!',
      icon: '🚀'
    }
  ];

  const languages = ['English', 'العربية', 'Français', 'Español'];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      onComplete();
    }
  };

  const handleSkip = () => {
    onComplete();
  };

  const handleBack = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-header">
        <div className="language-selector">
          <select 
            value={selectedLanguage} 
            onChange={(e) => setSelectedLanguage(e.target.value)}
            className="language-dropdown"
          >
            {languages.map(lang => (
              <option key={lang} value={lang}>{lang}</option>
            ))}
          </select>
        </div>
        <button className="skip-button" onClick={handleSkip}>
          Skip
        </button>
      </div>

      <div className="slide-container">
        <div className="slide-content">
          <div className="slide-icon">{slides[currentSlide].icon}</div>
          <h2 className="slide-title">{slides[currentSlide].title}</h2>
          <p className="slide-description">{slides[currentSlide].description}</p>
        </div>

        <div className="slide-indicators">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
            />
          ))}
        </div>
      </div>

      <div className="onboarding-footer">
        {currentSlide > 0 && (
          <button className="back-button" onClick={handleBack}>
            Back
          </button>
        )}
        <button className="next-button" onClick={handleNext}>
          {currentSlide === slides.length - 1 ? 'Get Started' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default Onboarding;

